import { Badge, Col, Image, ListGroup, Modal, Row } from 'react-bootstrap';
import CloseIcon from '@material-ui/icons/Close';
import CancelIcon from '@material-ui/icons/Cancel';
import PerfectScrollbar from 'react-perfect-scrollbar';
import HorizontalSeparator from 'app/components/common/HorizontalSeparator/HorizontalSeparator';
import {
  Button,
  Grid,
  MenuItem,
  //Select,
  InputLabel,
  Input,
  OutlinedInput,
  Box,
  Chip,
  Checkbox,
  ListItemText,
  FormHelperText,
  IconButton
} from '@material-ui/core';
import { TextField } from '../../components/common/TextField';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../_metronic/_partials/controls';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import MultipleSelect from 'app/components/common/MultipleSelect/MultipleSelect';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Autocomplete } from '@material-ui/lab';
import swal from 'sweetalert';
import SymptomModel from '../../models/Symptom';
import generalInfoModel from '../../models/GeneralInformation';

export default function NewSymptomModal({ open, onClose }) {
  const history = useHistory();

  const [symptomName, setSymptomName] = useState('');

  const [selectedBodyPart, setSelectedBodyPart] = useState('');

  const [reactSelectValue, setReactSelectValue] = useState([]);

  const [symptomDetails, setSymptomDetails] = useState([{ name: '', options: '', type: '' }]);

  const handleSubmit = async e => {
    try {
      if (symptomName == null || symptomName == '') {
        swal({
          title: 'Symptom name',
          text: 'Symptom name cannot be empty',
          icon: 'error'
        });
        return;
      }

      let Symptom = new SymptomModel();

      let submitDetail = [];

      submitDetail.push({ detail_name: symptomName, options: ["Ya", "Tidak"], type: "radio" })

      let body = {
        name: symptomName,
        body_part: "Others",
        details: submitDetail,
        from_diagnose: true
      };

      console.log('submitting', body);

      setSymptomName('');
      setSelectedBodyPart('');
      setSymptomDetails([{ name: '', options: '', type: '' }]);
      setReactSelectValue([]);

      let result = await Symptom.create(body);

      swal({
        title: 'Success',
        text: "Symptom '" + result.name + "' has been added successfully",
        icon: 'success'
      }).then(() => {
        /* history.push('/symptom/' + result.id); */
        onClose()
      });
    } catch (e) {
      console.log(e);

      swal({
        title: 'Error',
        text: e.error_message ? e.error_message : 'An Error Occurred',
        icon: 'error',
        customClass: {
          container: 'swal-z'
        }
      });
    }
  };

  useEffect(() => {
    //initializeGeneralInfo()
  }, []);
  return (
    <Modal size={'lg'} show={open} onHide={() => {}}>
      <Modal.Header style={{ border: 'none', display: 'block' }}>
        <div className={'d-flex'} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Modal.Title>Add New Symptom</Modal.Title>
            {/* <p>Choose Symptom below.</p> */}
          </div>
          <div>
            <IconButton
              style={{
                background: '#E8E8E8',
                borderRadius: '20px',
                fontSize: 12,
                padding: '5px'
              }}
              onClick={() => {
                onClose();
              }}
              aria-label="delete"
            >
              Close <CancelIcon fontSize="small" />
            </IconButton>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body style={{ paddingTop: 0 }}>
        <Card>
          <CardHeader title="Symptom details">
            {/* <CardHeaderToolbar>
            <Button color={'primary'} variant="contained" onClick={handleSubmit}>
              Save
            </Button>
          </CardHeaderToolbar> */}
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    // id="name"
                    value={symptomName}
                    onChange={e => setSymptomName(e.target.value)}
                    label="Symptom Name *"
                    input={<OutlinedInput label="Tag" />}
                    // helperText={touched.name ? errors.name : ''}
                    // error={touched.name && errors.name ? true : false}
                  />
                </Grid>
              </Grid>

              <br />
            </form>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <Button color={'primary'} variant="contained" onClick={handleSubmit}>
                Save
              </Button>
            </div>
          </CardBody>
        </Card>
      </Modal.Body>
    </Modal>
  );
}
